<template>
  <div></div>
</template>

<script>
export default {
  props: {
    frequencySelectId: {
      type: String,
      required: true
    },
    frequencyCountWrapperId: {
      type: String,
      default: 'frequency-count-wrapper'
    },
    frequencyUntilWrapperId: {
      type: String,
      default: 'frequency-until-wrapper'
    },
    frequencyCountInputName: {
      type: String,
      required: true
    },
    nextDueDateInputId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      frequencySelect: null,
      frequencyCountWrapper: null,
      frequencyUntilWrapper: null,
      frequencyCountInput: null,
      frequencyUntilInput: null,
      nextDueDateInput: null,
      nextDueDatePreviewEl: null,
      nextDueDateValueEl: null,
      maxValues: {
        none: 0,
        weekly: 8,
        monthly: 11,
        yearly: 15
      }
    };
  },
  methods: {
    getMaxForFrequency(frequency) {
      return this.maxValues[frequency] || 1;
    },
    toggleFrequencyFields() {
      const frequency = this.frequencySelect.value;
      const isNone = frequency === 'none';
      const max = this.getMaxForFrequency(frequency);

      if (this.frequencyCountWrapper) {
        this.frequencyCountWrapper.style.display = isNone ? 'none' : 'block';
      }

      if (this.frequencyUntilWrapper) {
        this.frequencyUntilWrapper.style.display = isNone ? 'none' : 'block';
      }

      if (!this.frequencyCountInput) {
        this.updateNextDueDatePreview();
        return;
      }

      this.frequencyCountInput.setAttribute('max', max);
      this.frequencyCountInput.setAttribute('min', isNone ? '0' : '1');

      const currentValue = parseInt(this.frequencyCountInput.value, 10) || 0;

      if (isNone) {
        this.frequencyCountInput.value = '0';
        this.updateNextDueDatePreview();
        return;
      }
      if (currentValue === 0 || this.frequencyCountInput.value === '') {
        this.frequencyCountInput.value = '1';
      } else if (currentValue > max) {
        this.frequencyCountInput.value = max.toString();
      }

      this.updateNextDueDatePreview();
    },
    parseDate(dateStr) {
      if (!dateStr) return null;
      const parts = dateStr.split('/');
      if (parts.length !== 3) return null;
      const date = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
      return isNaN(date.getTime()) ? null : date;
    },
    calculateNextOccurrence(baseDateStr, frequency, count, frequencyUntilStr) {
      if (!baseDateStr || !frequency || frequency === 'none' || count <= 0) {
        return null;
      }

      const baseDate = this.parseDate(baseDateStr);
      if (!baseDate) return null;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const frequencyUntil = this.parseDate(frequencyUntilStr);

      let nextDate = new Date(baseDate);
      let iterations = 0;

      while (nextDate <= today) {
        if (frequency === 'weekly') {
          nextDate.setDate(nextDate.getDate() + count * 7);
        } else if (frequency === 'monthly') {
          nextDate.setMonth(nextDate.getMonth() + count);
        } else if (frequency === 'yearly') {
          nextDate.setFullYear(nextDate.getFullYear() + count);
        } else {
          return null;
        }

        if (++iterations > 1000) return null;
      }

      if (frequencyUntil && nextDate > frequencyUntil) {
        return null;
      }

      const day = String(nextDate.getDate()).padStart(2, '0');
      const month = String(nextDate.getMonth() + 1).padStart(2, '0');
      return `${day}/${month}/${nextDate.getFullYear()}`;
    },
    updateNextDueDatePreview() {
      if (!this.nextDueDatePreviewEl || !this.nextDueDateValueEl) return;

      const frequency = this.frequencySelect ? this.frequencySelect.value : null;
      const count = this.frequencyCountInput ? parseInt(this.frequencyCountInput.value, 10) : 0;
      const baseDateStr = this.nextDueDateInput ? this.nextDueDateInput.value : null;
      const frequencyUntilStr = this.frequencyUntilInput ? this.frequencyUntilInput.value : null;

      const nextDate = this.calculateNextOccurrence(baseDateStr, frequency, count, frequencyUntilStr);

      if (nextDate) {
        this.nextDueDateValueEl.textContent = nextDate;
        this.nextDueDatePreviewEl.style.display = 'block';
      } else {
        this.nextDueDatePreviewEl.style.display = 'none';
      }
    }
  },
  mounted() {
    this.frequencySelect = document.getElementById(this.frequencySelectId);
    this.frequencyCountWrapper = document.getElementById(this.frequencyCountWrapperId);
    this.frequencyUntilWrapper = document.getElementById(this.frequencyUntilWrapperId);
    this.frequencyCountInput = document.querySelector(`[name="${this.frequencyCountInputName}"]`);
    this.frequencyUntilInput = this.frequencyUntilWrapper ? this.frequencyUntilWrapper.querySelector('input') : null;

    if (this.frequencyUntilInput) {
      this.frequencyUntilInput.addEventListener('change', this.updateNextDueDatePreview);
    }

    if (this.nextDueDateInputId) {
      this.nextDueDateInput = document.getElementById(this.nextDueDateInputId);
      this.nextDueDatePreviewEl = document.getElementById('next-due-date-preview');
      this.nextDueDateValueEl = document.getElementById('next-due-date-value');

      if (this.nextDueDateInput) {
        this.nextDueDateInput.addEventListener('change', this.updateNextDueDatePreview);
      }
    }

    if (this.frequencyCountInput) {
      this.frequencyCountInput.addEventListener('input', this.updateNextDueDatePreview);
    }

    if (this.frequencySelect) {
      this.frequencySelect.addEventListener('change', this.toggleFrequencyFields);
      $(this.frequencySelect).on('select2:select', this.toggleFrequencyFields);
      this.toggleFrequencyFields();
    }
  },
  beforeUnmount() {
    if (this.frequencySelect) {
      this.frequencySelect.removeEventListener('change', this.toggleFrequencyFields);
      $(this.frequencySelect).off('select2:select', this.toggleFrequencyFields);
    }
    if (this.nextDueDateInput) {
      this.nextDueDateInput.removeEventListener('change', this.updateNextDueDatePreview);
    }
    if (this.frequencyCountInput) {
      this.frequencyCountInput.removeEventListener('input', this.updateNextDueDatePreview);
    }
    if (this.frequencyUntilInput) {
      this.frequencyUntilInput.removeEventListener('change', this.updateNextDueDatePreview);
    }
  }
};
</script>